import React from 'react';
import PropsTypes from 'prop-types';
import styled from 'styled-components';
import { Link } from "gatsby"
import { downloadsLinks} from '../../store/playlist';
const Container = styled.div`
    box-sizing: border-box;
    overflow: scroll;
    padding-top: 10px;
  `;

  const Item = styled.div`
    width: 90%;
    height: 45px;
    cursor: pointer;
    color: #b2b2b2;
    margin-left: 2rem;
    margin-top: 1rem;
    display: flex;
    box-sizing: border-box;
    flex-direction: row;
    align-content: center;
    align-items: center;
    border-bottom: 1px solid #666;
  `;

  const Image = styled.img`
    border-radius: 50%;
    width: 40px;
    height: 40px;
  `;

  const Descr = styled.div`
    display: flex;
    flex-direction: column;
    margin-left: 1rem;
    width: 100%;
    justify-content: center;
  `;

  const Title = styled.p`
    font-weight: bold;
    font-size: 0.8rem;
    margin: 0;
  `;

  const Author = styled.p`
    text-transform: uppercase;
    font-size: 0.6rem;
    font-weight: 300;
  `;
  const Download = styled.a`
  border-radius: 50%;
  width: 40px;
  height: 40px;
`;

const Icon = styled.svg`
  width: 24px;
  height: 24px;
`


export function Downloads(props) {
  

  return (
    <Container>
      {downloadsLinks.map(track => (
        <Item key={track.id} 
        // onClick={() => props.onChangeTrack(track.id)}
        >
          <Image src={track.cover} alt="cover" />
          <Descr>
            <Title>{track.title}</Title>
            <Author>{track.author}</Author>
          </Descr>
          <Download href={track.url} title="Descargar" target="_blank" download>
            <Icon aria-hidden="true" focusable="false" data-prefix="fal" data-icon="arrow-circle-down" role="img" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 512 512" className="svg-inline--fa fa-arrow-circle-down fa-w-16"><path fill="#FFFFFF" d="M256 8C119 8 8 119 8 256s111 248 248 248 248-111 248-248S393 8 256 8zm216 248c0 118.7-96.1 216-216 216-118.7 0-216-96.1-216-216 0-118.7 96.1-216 216-216 118.7 0 216 96.1 216 216zm-92.5-4.5l-6.9-6.9c-4.7-4.7-12.5-4.7-17.1.2L273 330.3V140c0-6.6-5.4-12-12-12h-10c-6.6 0-12 5.4-12 12v190.3l-82.5-85.6c-4.7-4.8-12.4-4.9-17.1-.2l-6.9 6.9c-4.7 4.7-4.7 12.3 0 17l115 115.1c4.7 4.7 12.3 4.7 17 0l115-115.1c4.7-4.6 4.7-12.2 0-16.9z" className=""></path></Icon>
          </Download>
        </Item>
      ))}
    </Container>
  );
}
